import { ICellRendererParams } from 'ag-grid-community';

import { BomPartNumber } from 'bom/elements';
import { BomPartType } from 'bom/enums';
import { IBomPart } from 'bom/types';
import { getAgGridTableCellData } from 'core/utils';
import { PartListColId } from 'elements/components/PartList/enums';
import { IComponentTemplate } from 'elements/types';

interface IProps extends ICellRendererParams<IComponentTemplate> {
  onPartNumberClick: (part: IComponentTemplate) => void;
}

export const PartNumberCell = ({ onPartNumberClick, ...props }: IProps) => {
  const data = getAgGridTableCellData(props, PartListColId.PART);

  if (!data) {
    return props?.value;
  }

  const bomPart = mapPartToBomPart(data);

  return <BomPartNumber bomPart={bomPart} onPartClick={() => onPartNumberClick(data)} />;
};

const mapPartToBomPart = (part: IComponentTemplate): IBomPart =>
  ({
    id: part.id,
    type: BomPartType.PART,
    manufacturerId: part.manufacturerId,
    manufacturerName: part.manufacturerName,
    verified: Boolean(part.verified),
    partArr: {
      number: part.part,
      manufacturerId: part.manufacturerId,
      manufacturerName: part.manufacturerName,
      verified: part.verified,
      description: part.partDescription,
      descriptionLong: part.partDescriptionLong,
    },
  }) as IBomPart;
